"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class;

var styles = {
  componentId: 'dpuxe',
  template: function template(theme) {
    return "\n\n.dpuxe_bGBk{background:".concat(theme.background || 'inherit', ";height:").concat(theme.height || 'inherit', ";margin:").concat(theme.margin || 'inherit', ";overflow:hidden}");
  },
  'root': 'dpuxe_bGBk'
};

/**
---
parent: Menu
---
@module MenuItemSeparator
**/
var MenuItemSeparator = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MenuItemSeparator, _Component);

  function MenuItemSeparator() {
    (0, _classCallCheck2.default)(this, MenuItemSeparator);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MenuItemSeparator).apply(this, arguments));
  }

  (0, _createClass2.default)(MenuItemSeparator, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", Object.assign({}, this.props, {
        role: "presentation",
        className: styles.root
      }));
    }
  }]);
  MenuItemSeparator.displayName = "MenuItemSeparator";
  return MenuItemSeparator;
}(_react.Component)) || _class) || _class);
var _default = MenuItemSeparator;
exports.default = _default;